import app from '@/app';
import templateUrl from './organization-import-dialog.html';

/* @ngInject */
function Controller($translate, Upload) {
	var $ctrl = this;

	$ctrl.$onInit = () => {
		$ctrl.uploading = $ctrl.resolve.files.length;
		$ctrl.resolve.files.forEach(file => {
			file.progress = 0;
		});

		$ctrl.resolve.files.forEach(file => {
			file.upload = Upload.upload({
				url: '/api/organizations/import/excel',
				data: { file: file }
			});

			file.upload.then(onSuccess, onError, onProgress);

			// The import itself runs in the background: this only confirms the upload was
			// accepted and points the user to the processing list and the import history.
			function onSuccess(response) {
				--$ctrl.uploading;
				file.progress = 100.0;
				file.result = 'success';
				file.message = $translate.instant('organization.import.start', { name: file.name });
			}

			function onError(response) {
				--$ctrl.uploading;
				file.progress = 100.0;
				if (response.data && response.data.errors) {
					file.errors = response.data.errors;
				} else if (response.data && response.data.message) {
					file.errors = [$translate.instant(response.data.message, response.data.params)];
				} else {
					file.errors = [$translate.instant('message.unexpectedError')];
				}
				file.result = 'danger';
			}

			function onProgress(event) {
				file.progress = Math.min(100, parseInt((90.0 * event.loaded) / event.total));
			}
		});
	};
}

app.component('organizationImportDialog', {
	templateUrl,
	controller: Controller,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});
